import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "helpers/url_helper";
import { get, post, del, put } from "helpers/api_helper";
import { toast } from "react-toastify";
import { getValuesSocketData } from "helpers/secretManager";

export const getRoadmapsList = createAsyncThunk(
  "getRoadmapsList",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(`${URL.GET_ROADMAP_LIST}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const addRoadmapApi = createAsyncThunk(
  "addRoadmapApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.ADD_ROADMAP, data, { signature, nonce });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message || "Something went wrong!", null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const editRoadmapApi = createAsyncThunk(
  "editRoadmapApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await put(URL.EDIT_ROADMAP + data._id, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const deleteRoadmap = createAsyncThunk(
  "deleteRoadmap",
  async ({ data, callback }, Thunk) => {
    try {
      if (!data || !data._id) {
        const errorMsg = "Roadmap ID is required";
        toast.error(errorMsg);
        callback && callback(errorMsg, null);
        return Thunk.rejectWithValue(errorMsg);
      }

      const { signature, nonce } = await getValuesSocketData();

      if (!signature || !nonce) {
        const errorMsg = "Signature or nonce missing";
        toast.error(errorMsg);
        callback && callback(errorMsg, null);
        return Thunk.rejectWithValue(errorMsg);
      }

      // Fixed: Pass signature and nonce directly in config, not nested
      let response = await del(URL.DELETE_ROADMAP + data._id, {
        signature, // Not nested in an object
        nonce, // Not nested in an object
      });

      if (response?.status === "failure") {
        toast.error(response?.message || "Failed to delete roadmap");
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }

      toast.success(response?.message || "Roadmap deleted successfully");
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.error("Delete roadmap error:", error);
      const errorMessage = error?.message || "Something went wrong!";
      toast.error(errorMessage);
      callback && callback(errorMessage, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const sortRoadmaps = createAsyncThunk(
  "sortRoadmaps",
  async ({ data, callback }, Thunk) => {
    try {
      if (!data || !data.data || !Array.isArray(data.data)) {
        const errorMsg = "Invalid sorting data format";
        toast.error(errorMsg);
        callback && callback(errorMsg, null);
        return Thunk.rejectWithValue(errorMsg);
      }

      const { signature, nonce } = await getValuesSocketData();

      if (!signature || !nonce) {
        const errorMsg = "Signature or nonce missing";
        toast.error(errorMsg);
        callback && callback(errorMsg, null);
        return Thunk.rejectWithValue(errorMsg);
      }

      let response = await post(`${URL.SORT_ROADMAPS}`, data, {
        signature,
        nonce,
      });

      if (response?.status === "failure") {
        toast.error(response?.message || "Failed to update sorting");
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }

      // Don't show success toast here - let the component handle it
      // toast.success(response?.message || "Sorting updated successfully");
      callback && callback(null, response.data || response);
      return response;
    } catch (error) {
      console.error("Sort roadmaps error:", error);
      const errorMessage = error?.message || "Failed to update sorting";
      toast.error(errorMessage);
      callback && callback(errorMessage, null);
      return Thunk.rejectWithValue(error);
    }
  },
);
